"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Wallet = function Wallet(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("svg", {
    className: className,
    width: "52",
    height: "52",
    viewBox: "0 -16 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "m376 300c-5.519531 0-10 4.480469-10 10s4.480469 10 10 10 10-4.480469 10-10-4.480469-10-10-10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m70 480h392c16.542969 0 30-13.457031 30-30v-91.71875c11.640625-4.128906 20-15.246094 20-28.28125v-40c0-13.035156-8.359375-24.152344-20-28.28125v-91.71875c0-16.542969-13.457031-30-30-30h-16v-50c0-16.542969-13.457031-30-30-30h-95.855469l-57.074219-57.070312c-3.292968-3.292969-8.421874-3.878907-12.371093-1.410157l-93.566407 58.480469h-107.132812c-27.570312 0-50 22.429688-50 50v300c0 38.597656 31.402344 70 70 70zm422-150c0 5.511719-4.484375 10-10 10h-103.859375c-15.773437 0-29.410156-10.699219-31.71875-24.886719-3.125-19.195312 11.640625-35.113281 29.578125-35.113281h106c5.515625 0 10 4.484375 10 10zm-237.445312-307.304688 77.300781 77.304688h-200.988281zm-204.554688 57.304688h75.132812l-32 20h-23.132812c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h306c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-15.855469l-20-20h75.855469c5.515625 0 10 4.484375 10 10v50h-376c-16.542969 0-30-13.457031-30-30s13.457031-30 30-30zm-30 69.972656c8.363281 6.292969 18.753906 10.027344 30 10.027344h412c5.515625 0 10 4.484375 10 10v90h-96c-30.898438 0-54.316406 27.617188-49.320312 58.328125 3.867187 23.753906 25.992187 41.671875 51.460937 41.671875h93.859375v90c0 5.511719-4.484375 10-10 10h-392c-27.570312 0-50-22.429688-50-50zm0 0"
  }), "]", _react["default"].createElement("path", {
    d: "m462 300h-46c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h46c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m76 440h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m156 440h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m236 440h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m316 440h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m396 440h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m76 200h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m156 200h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m236 200h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m316 200h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }), _react["default"].createElement("path", {
    d: "m396 200h40c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-40c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"
  }));
};

Wallet.displayName = 'Wallet';
Wallet.propTypes = {
  className: _propTypes["default"].string
};
Wallet.defaultProps = {
  className: ''
};
var _default = Wallet;
exports["default"] = _default;